import {
  getActiveBudgetScope,
  initializeWalletWatchDb,
  listBudgetCategoryOptions,
  listExpenseRows,
  updateBudgetRows,
  updateExpenseRows
} from "../../lib/storage/walletWatchDb.js";
import { restoreProfileDataExport } from "../../features/settings/profileDataExport.js";

export async function fetchCurrentProfileSnapshot() {
  await initializeWalletWatchDb();
  const scope = await getActiveBudgetScope();
  const [budgetCategories, expenseRows] = await Promise.all([
    listBudgetCategoryOptions(scope.profileId, scope.year),
    listExpenseRows(scope.profileId, scope.year)
  ]);

  return {
    scope,
    isVirgin: budgetCategories.length === 0 && expenseRows.length === 0
  };
}

async function restoreIntoCurrentProfile(payload, scope) {
  const targetYear = String(scope.year ?? payload.activeYear ?? payload.years?.[0]?.year ?? "");

  if (!targetYear) {
    throw new Error("Unable to determine the target year for import.");
  }

  const budgetEntry = (payload.budgets ?? []).find((entry) => String(entry?.year ?? "") === targetYear) ?? { rows: [] };
  const expenseEntry = (payload.expenses ?? []).find((entry) => String(entry?.year ?? "") === targetYear) ?? { rows: [] };

  await updateBudgetRows(scope.profileId, targetYear, budgetEntry.rows ?? []);
  await updateExpenseRows(scope.profileId, targetYear, expenseEntry.rows ?? [], { allowEmptyReplace: true });
}

export async function importProfileData(payload) {
  const { scope, isVirgin } = await fetchCurrentProfileSnapshot();

  if (isVirgin) {
    await restoreIntoCurrentProfile(payload, scope);
    return { scope, importedIntoCurrent: true };
  }

  const result = await restoreProfileDataExport(payload);

  return {
    scope: result.scope,
    profile: result.profile,
    importedIntoCurrent: false
  };
}
